import { render, staticRenderFns } from "./aboutNectios.vue?vue&type=template&id=2d95528c"
import script from "./aboutNectios.vue?vue&type=script&lang=js"
export * from "./aboutNectios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports